import * as Dialog from "@radix-ui/react-dialog";

import { useSnackbar } from "../../_contexts/snackbar";
import { Link } from "../ui/link";

export default function AskToSendUrlDialog({
  isOpen,
  onOpenChange,
  invitationUrl,
}: {
  isOpen: boolean;
  onOpenChange: (isOpen: boolean) => void;
  invitationUrl: string;
}) {
  const showSnackBar = useSnackbar();

  return (
    <Dialog.Root open={isOpen} onOpenChange={onOpenChange} modal={true}>
      <Dialog.Portal>
        <Dialog.Overlay className="sd-overlay">
          <Dialog.Content
            className="sd-content w-[315px] p-[30px] md:w-[690px]"
            onInteractOutside={(e) => e.preventDefault()}
            onEscapeKeyDown={(e) => e.preventDefault()}
            onPointerDownOutside={(e) => e.preventDefault()}
          >
            <Dialog.Title className="font-bold">
              SANU 2nd Home に招待したい方へ、URL を共有してください。
            </Dialog.Title>
            <Dialog.Description>
              <div className="mx-auto py-[30px]">
                <p className="mb-[30px] text-[14px]">
                  このチケットはご本人ではご利用いただけません。URL
                  を受け取った方が、ご自身で予約を行えます。
                </p>
                <div className="flex flex-col items-center pb-[20px]">
                  <button
                    data-analytics-id="reservation_form_clicked_gift_invitation_copy"
                    className="old-btn-orange w-[240px] text-[14px] text-white"
                    onClick={() => {
                      navigator.clipboard.writeText(invitationUrl);
                      showSnackBar({ message: "URL をコピーしました" });
                    }}
                  >
                    招待 URL をコピーする
                  </button>
                </div>
              </div>
              <Link
                data-analytics-id="reservation_form_clicked_member_top"
                className="btn-primary mx-auto w-full md:w-[315px]"
                href="/member"
              >
                会員トップに戻る
              </Link>
            </Dialog.Description>
          </Dialog.Content>
        </Dialog.Overlay>
      </Dialog.Portal>
    </Dialog.Root>
  );
}
